import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["cx", "cy", "r", "stroke-width"]
const _hoisted_3 = ["cx", "cy", "r", "stroke-width", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_4 = { class: "progress-ring__content" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressRing',
  props: {
    progress: {},
    size: { default: 44 },
    stroke: { default: 5 }
  },
  setup(__props: any) {

const props = __props

const radius = computed(() => (props.size - props.stroke) / 2)
const circumference = computed(() => 2 * Math.PI * radius.value)
const dashOffset = computed(
  () => circumference.value * (1 - Math.min(1, Math.max(0, props.progress))),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "progress-ring",
    style: _normalizeStyle({ width: `${__props.size}px`, height: `${__props.size}px` })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      width: __props.size,
      height: __props.size,
      viewBox: `0 0 ${__props.size} ${__props.size}`
    }, [
      _createElementVNode("circle", {
        class: "progress-ring__track",
        cx: __props.size / 2,
        cy: __props.size / 2,
        r: radius.value,
        "stroke-width": __props.stroke
      }, null, 8, _hoisted_2),
      _createElementVNode("circle", {
        class: "progress-ring__fill",
        cx: __props.size / 2,
        cy: __props.size / 2,
        r: radius.value,
        "stroke-width": __props.stroke,
        "stroke-dasharray": circumference.value,
        "stroke-dashoffset": dashOffset.value
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_1)),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 4))
}
}

})